import { createApi, fetchBaseQuery } from "@reduxjs/toolkit/query/react";
import { GetArticlesResponse, FilterResponseItem } from "../../interfaces/types";

export const apiSlice = createApi({
    reducerPath: "api",
    baseQuery: fetchBaseQuery({
        baseUrl: `/arsht-api/filterpage/`
    }),
    endpoints(builder) {
        return {
            getArticleItems: builder.query({
                query: (request: any) => `GetItems?pageid=${request}`,
                transformResponse: (response: GetArticlesResponse) => {
                    return response;
                }
            })
        };
    },
});

export const { useGetArticleItemsQuery } = apiSlice;